export const EC_TASK = 'verify';
export const CONFORMA_TASK = 'verify-conforma';
export const ROXCTL_SCAN_TASK = 'roxctl-scan';

export const ENTERPRISE_CONTRACT_LABEL = 'build.appstudio.redhat.com/pipeline';
